<script setup lang="ts">
import {
  PhxsgSection as PhxsgCoreSection,
  type PhxsgSectionProps as PhxsgCoreSectionProps,
} from '@sg-core/src/View/Components/Atoms/Section';

export type PhxsgSectionTheme = 'inherit' | 'white' | 'grey' | 'black';
export type PhxsgSectionSpacing = '2xl' | 'base' | 'top-base' | 'top-0' | 'tight' | 'full';

export interface PhxsgSectionProps extends PhxsgCoreSectionProps {
  spacing?: PhxsgSectionSpacing;
  theme?: PhxsgSectionTheme;
}

defineProps<PhxsgSectionProps>();
</script>

<template>
  <PhxsgCoreSection v-bind="$props" :class="[{ [`phxsg-theme-${theme}`]: theme }]">
    <slot />
  </PhxsgCoreSection>
</template>

<style src="./section.css" />
